import { DropDown } from "./DropDown";
import { setReqStatus } from "services/auth/rideApis";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";

export const RequestBar = ({ request, onStatusChange }) => {
    const { id } = useParams();
    const [selected, setSelected] = useState(request.status.toLowerCase());
    const setStatusHandler = async (selected) => {
        try {
            await setReqStatus(id, request.id, selected);
            setSelected(selected);
            // Trigger parent component to refetch ride details
            if (onStatusChange) {
                onStatusChange();
            }
        } catch (error) {
            console.error("Failed to update request status:", error);
            toast.error("Failed to update status");
        }
    };

    return (
        <div className="w-full">
            {request && (
                <div className="flex gap-4 justify-between items-center border-b border-zinc-200 bg-white py-2 px-3 rounded-lg shadow-sm mb-2">
                    <div className="font-medium text-zinc-800">{request.interestedUser.name}</div>
                    <div className="text-xs text-zinc-500 max-md:hidden">{request.createdAt.split("T")[0]}</div>
                    <div className="flex items-center gap-2 px-1">
                        <DropDown handler={setStatusHandler} selected={selected} />
                    </div>
                </div>
            )}
        </div>
    );
};